import { memo } from 'react';

import { StandardTabs } from '@dreryk/react-components';

import { MEDICAL_PROFILE_TEMPLATE_CODE_LIST } from '../../common/medicalProfile/medicalProfileTemplateCodes';

import { DeepLinkTarget } from './header/SectionSummary.types';
import { MedicalProfileTab } from './tab/MedicalProfileTab';
import { MedicalProfileTabLoader } from './tab/MedicalProfileTab.loader';

type MedicalProfileModalTabsProps = {
   readonly patientId: number;
   readonly initialTarget?: DeepLinkTarget | null;
};

export const MedicalProfileModalTabs = memo(
   (props: MedicalProfileModalTabsProps): JSX.Element => (
      <StandardTabs testId={'medicalProfileTabs'} initialActiveTabId={props.initialTarget?.templateCode}>
         {MEDICAL_PROFILE_TEMPLATE_CODE_LIST.map((entry) => (
            <StandardTabs.Tab
               key={entry.templateCode}
               id={entry.templateCode}
               testId={entry.templateCode}
               label={entry.tabLabel}
            >
               <MedicalProfileTabLoader templateCode={entry.templateCode} patientId={props.patientId}>
                  {({ template, structuredSurvey }) => (
                     <MedicalProfileTab
                        templateCode={entry.templateCode}
                        template={template}
                        structuredSurvey={structuredSurvey}
                        expandedSectionId={
                           props.initialTarget?.templateCode === entry.templateCode
                              ? props.initialTarget.sectionId
                              : undefined
                        }
                     />
                  )}
               </MedicalProfileTabLoader>
            </StandardTabs.Tab>
         ))}
      </StandardTabs>
   )
);
